// @ts-nocheck
import siteMessage from "@insite/client-framework/SiteMessage";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { PageErrorWrapper, PageErrorWrapperStyles } from "@insite/content-library/Components/PageErrorWrapper";
import OrderLayout from "@store/Library/Components/Toolkit/Layout/OrderLayout";
import useQueryString from "@toolkit/Framework/Common/Hooks/useQueryString";
import { useWishListState } from "@toolkit/Framework/Store/Data/MyLists/MyListsHooks";
import React, { FC } from "react";

export interface StaticListStaticListPageContainerStyles {
    pageErrorWrapper?: PageErrorWrapperStyles;
}

export const staticListStaticListPageContainerStyles: StaticListStaticListPageContainerStyles = {}; // Starter Custom Code

type Props = WidgetProps;

const styles = staticListStaticListPageContainerStyles;

const StaticListPageContainer: FC<Props> = ({ id: widgetId }) => {
    const { id } = useQueryString();
    const wishListDataView = useWishListState(id);

    return (
        <PageErrorWrapper
            value={wishListDataView}
            notFoundMessage={siteMessage("Lists_List_NotFound")}
            extendedStyles={styles.pageErrorWrapper}
        >
            <OrderLayout id={widgetId} />
        </PageErrorWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: StaticListPageContainer,
    definition: {
        group: "Static List",
        displayName: "Page Container",
        allowedContexts: ["StaticListPage"],
    },
};
export default widgetModule;
